var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQueue = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.09091 10H12.9091",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.09091 12.9091H12.9091",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.09091 7.0909H12.9091",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7787 15.8182C15.6966 15.8182 16.4413 15.0742 16.4413 14.1557V10.8313L17.2726 10L16.4413 9.16873V5.84436C16.4413 4.92582 15.6973 4.18182 14.7787 4.18182M5.22108 4.18182C4.30253 4.18182 3.55853 4.92582 3.55853 5.84436V9.16873L2.72726 10L3.55853 10.8313V14.1557C3.55853 15.0742 4.30253 15.8182 5.22108 15.8182",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgQueue;